import { BsPinAngle } from "react-icons/bs";
import { GiBrain } from "react-icons/gi";
import { PiChartLineUp } from "react-icons/pi";
import "../assets/styles/netfy.css";
import netfyLogo from "../assets/svgs/netfy_Logo.svg";
import MobileViewLayout from "../layouts/MobileViewLayout";

const Netfy = () => {
  return (
    <MobileViewLayout>
      <div className="d-flex flex-column align-items-center justify-content-start w-100 text-center tele-container">
        <div className="w-100" style={{ backgroundColor: "#F5F5F5" }}>
          <div
            className="text-center"
            style={{ backgroundColor: "#32B0ED", padding: "9px 0px" }}
          >
            <p
              className="mb-0"
              style={{ color: "#fff", fontSize: "16px", fontWeight: "600" }}
            >
              Telegram
            </p>
          </div>
          <img src={netfyLogo} alt="netfy" style={{ marginTop: "43px" }} />
          <p className="mb-0 capital-text">Netfy Capital</p>
          <p className="mb-0 bot-text">@netfycapital_bot</p>
          <div
            className="text-start"
            style={{ marginTop: "30px", padding: "0px 53px" }}
          >
            <p className="mb-0 points-text">
              <i className="fas fa-chart-line" style={{ color: "black" }}></i>{" "}
              <PiChartLineUp size={20} /> Learn more about real-asset-backed
              financial tools and updates.
            </p>
            <p className="points-text">
              <GiBrain size={20} /> Access insights and general information via
              our Telegram channel.
            </p>
            <p className="points-text">
              <BsPinAngle size={20} /> For informational purposes only. No
              financial advice is provided.
            </p>
          </div>
          <div style={{ padding: "0px 15px", marginTop: "32px" }}>
            <button
              className="w-100 btn-common btn-1"
              onClick={() => window.open("https://t.me/netfycapital", "_blank")}
            >
              OPEN IN TELEGRAM
            </button>
            <button
              className="w-100 btn-common btn-2"
              onClick={() => window.open("https://t.me/netfycapital", "_blank")}
            >
              DON’T HAVE TELEGRAM YET? TRY IT NOW!
            </button>
          </div>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default Netfy;
